import React from 'react';
import { Block } from '../../factories/types';

export type ItemContext = {
	template: React.ComponentType<Parameters<Block<'item'>>[0]>;
};

/** This does nothing in production, but the live preview adds annotations */
export const Item: (Block<'item', ItemContext>) = ({ context: { template: Template } = {}, ...props }) => {
	if (!Template) {
		throw new Error(`Item type not provided for ${props.data.sys.contentType.sys.id}: ${props.data.sys.id}`);
	}

	return <Template {...props} />;
};
